import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
        FETCH_FRANCHISE_DATA_SUCCESS
        FETCH_FRANCHISE_DATA_FAILURE
        SET_DETAILS
        SET_IS_SSR
    `,
    {
        prefix: "franchise/"
    }
);
